import { Button, Icon, Text } from '../../common/components';
import { t } from '../../common/i18n';

const namespace = 'Issues';

interface IssueReportCtaProps {
  onReport: () => void;
}

/**
 * Výzva k nahlášení přímo v obsahu stránky – vlastník (primární uživatel modulu)
 * nemusí hledat akci vpravo nahoře v hlavičce. Vzor dlaždice DeadlineTip.
 */
export const IssueReportCta: React.FC<IssueReportCtaProps> = ({ onReport }) => (
  <div className="IssueCta">
    <div className="IssueCta__icon">
      <Icon name="bullHorn" />
    </div>
    <div className="IssueCta__body">
      <Text as="div" size="body-medium" weight="600" color="Neutral800">
        {t('Cta.title', namespace)}
      </Text>
      <Text as="div" size="body-small" color="Neutral600">
        {t('Cta.text', namespace)}
      </Text>
    </div>
    <Button title={t('Cta.action', namespace)} onClick={onReport} />
  </div>
);

export default IssueReportCta;
